import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CustomTooltipDirective } from '@core-utils';

@Component({
  selector: 'ui-bullet',
  imports: [CustomTooltipDirective],
  templateUrl: './bullet.component.html',
  styleUrl: './bullet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulletComponent {
  text = input<string | number>('');
  class = input<string>('');
  tooltip = input<string>('');
}
